(function ($) {
    'use strict';

    // Sets the disabled state of an element
    function setDisabled(disabled) {

        if ($(this).data("auth") == "forbidden") {
            return;
        }

        $(this).prop("disabled", disabled === undefined ? true : disabled);

        return this;
    }

    // Sets the checked state of a checkbox
    function setChecked(checked) {
        $(this).prop("checked", checked === undefined ? true : checked);

        return this;
    }

    jQuery.fn.extend({
        setDisabled,
        setChecked
    });

})(jQuery);